// @ts-nocheck 1f1d2e4b
import constants from '#packages/constants';

export default {
  allowConnectToDB: true,
  skipInQuickEditPanel: true,
  overrideProportionalResize: true,
  overridesWhenReferred: {
    gfpp: {
      disableActions: [constants.ROOT_COMPS.GFPP.ACTIONS.DESIGN],
    },
  },
};
